
namespace GeniuzPOS.Product {
    
    @Serenity.Decorators.registerClass()
    export class CsCategoryDialog extends Serenity.EntityDialog<CsCategoryRow, any> {
        protected getFormKey() { return CsCategoryForm.formKey; }
        protected getIdProperty() { return CsCategoryRow.idProperty; }
        protected getLocalTextPrefix() { return CsCategoryRow.localTextPrefix; }
        protected getNameProperty() { return CsCategoryRow.nameProperty; }
        protected getService() { return CsCategoryService.baseUrl; }
        protected getDeletePermission() { return CsCategoryRow.deletePermission; }
        protected getInsertPermission() { return CsCategoryRow.insertPermission; }
        protected getUpdatePermission() { return CsCategoryRow.updatePermission; }

        protected form = new CsCategoryForm(this.idPrefix);
        
        protected afterLoadEntity() {
            super.afterLoadEntity();

            
            // console.log(Catcode);
            var Skucheck = Q.tryFirst(CsSkuRow.getLookup().items, x=> x.CatCode == this.entity.CatCode);            
            if (Skucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
            
        }
       
     
    }
}